import { createRouter, createWebHistory } from "vue-router";

import HomePage from "@/views/HomePage.vue";
import SettingPage from "@/views/SettingPage.vue";
// import testPage from "@/views/HomePageNew.vue";
import AboutPage from "@/views/AboutPage.vue";
import LoginPage from "@/views/common/LoginPage.vue";
import RegisterPage from "@/views/common/RegisterPage.vue";
import NotFoundPage from "@/routes/notFound.vue";
import AdminMain from "@/views/admin/AdminMain.vue";
import RoulettePage from '@/views/event/RoulettePage.vue'
import SlotMachinePage from '@/views/event/SlotMachinePage.vue'
import CustomerRegisterPage from "@/views/event/CustomerRegisterPage.vue";
import CustomerRegisterPageWait from "@/views/event/CustomerRegisterWaitPage.vue";
import IdentifyCard from "@/views/event/IdentifyCard.vue";
import mainIntro from "@/views/intro/mainIntro.vue";
import GiftClaim from "@/views/event/giftClaim.vue"; // 
import TermPage from "@/views/common/terms.vue";
import SubscriptionPage from "@/views/common/SubscriptionPage.vue";
import TokenChargePage from "@/views/common/TokenChargePage.vue";

const routes = [
  {
    path: '/',
    name: 'HomePage',
    component: HomePage
  },
  {
    path: '/about/:id',
    name: 'AboutPage',
    component: AboutPage
  },
  {
    path: '/setting',
    name: 'SettingPage',
    component: SettingPage
  },
  {
    path: '/login',
    name: 'LoginPage',
    component: LoginPage
  },
  {
    path: '/register',
    name: 'RegisterPage',
    component: RegisterPage
  },
  {
    path: '/terms',
    name: 'TermPage',
    component: TermPage
  },
  {
    path: '/admin',
    name: 'AdminPage',
    component: AdminMain,
  },
  {
    path: '/admin/group',
    name: 'GroupAdmin',
    component: () => import('@/views/admin/GroupAdmin.vue'),
  },
  {
    path: '/event/roulette',
    name: 'Roulette',
    component: RoulettePage,
    meta: { 
      title: ' 행운의 룰렛 - BODA',
      requiresAuth: false
    }
  },
  {
    path: '/event/slotmachine',
    name: 'SlotMachine',
    component: SlotMachinePage,
    meta: { 
      title: '🎰 행운의 룰렛 - BODA',
      requiresAuth: false
    }
  },
  {
    path: '/roulette/:token',
    name: 'RouletteShare',
    component: () => import('@/views/event/RoulettePage.vue'),
    meta: {
      title: '🎰 행운의 룰렛 - BODA',
      requiresAuth: false
    }
  },
  {
    path: '/event/register/:mb_id',
    name: 'CustomerRegister',
    component: CustomerRegisterPage
  },
  {
    path: '/event/register_wait',
    name: 'CustomerRegisterWait',
    component: CustomerRegisterPageWait
  }, 
  {
    path: '/event/card/:mb_id',
    name: 'IdentifyCard',
    component: IdentifyCard,
    meta: {
      title: '전자명함 - BODA',
      requiresAuth: false
    }
  },
  {
    path: '/intro/main',
    name: 'mainIntro',
    component: mainIntro
  },
  // 설계요청서 수신 페이지
  {
    path: '/design-request/:token',
    name: 'DesignRequestView',
    component: () => import('@/views/event/DesignRequestView.vue'),
    meta: {
      title: '설계요청서 - BODA',
      requiresAuth: false
    }
  },
  // 선물 수령 페이지
  {
    path: '/gift/:token',
    name: 'GiftClaim',
    component: GiftClaim,
    meta: {
      title: ' 선물 받기 - BODA',
      requiresAuth: false // 로그인 없이 접근 가능
    }
  },
  {
    path: '/subscription',
    name: 'SubscriptionPage',
    component: SubscriptionPage,
    meta: {
      title: '구독 플랜 - BODA'
    }
  },
  {
    path: '/token-charge',
    name: 'TokenChargePage',
    component: TokenChargePage,
    meta: {
      title: '토큰 충전 - BODA'
    }
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'NotFoundPage',
    component: NotFoundPage
  }
];

const router = createRouter({
  history: createWebHistory(),
  routes
});

export default router;